import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TableFooter from '@material-ui/core/TableFooter';
import { green, red } from '@material-ui/core/colors'; 
import PALLET_SIZE from '../models/PalletSize'
import CheckCircle from '@material-ui/icons/CheckCircle';

class TransactionsTable extends Component {
    renderBodyRows(){
      const { classes, handleRowClick, transactions } = this.props;

      if(!transactions) return null;
      
      return transactions.map(transaction => {
        let tableRowExtraProps = {};
        if (handleRowClick) {
          tableRowExtraProps = {
            ...tableRowExtraProps,
            onClick: ()=>handleRowClick(transaction),
            hover: true
          }
        }

        return (
          <TableRow key={transaction.id} {...tableRowExtraProps}>
            <TableCell>{transaction.campaign_prefix}/{transaction.token}</TableCell>
            <TableCell>{moment(transaction.created_at).format('lll')}</TableCell>
            <TableCell>{transaction.from_location ? transaction.from_location.name : (transaction.from_user ? ('User email: ' + transaction.from_user.email) : '-')}</TableCell>
            <TableCell>{transaction.location ? transaction.location.name : (transaction.user ? transaction.user.email : '-')}</TableCell>
            <TableCell numeric>{transaction.weight} kg</TableCell>
            <TableCell>{PALLET_SIZE[transaction.pallet_size]}</TableCell>
            <TableCell>{transaction.delivered_at && <CheckCircle className={classes.delivered}/>}</TableCell>
          </TableRow>
        );
      })
    }
  
    renderHeaderRows(){
      return(
        <TableRow>
            <TableCell>Group/Token</TableCell>
            <TableCell>Timestamp</TableCell>
            <TableCell>From</TableCell>
            <TableCell>To</TableCell>
            <TableCell numeric>Weight</TableCell>
            <TableCell>Pallet size</TableCell>
            <TableCell>Delivered</TableCell>
        </TableRow>
      );
    }
  
    render() {
      const { onChangePage, onChangeRowsPerPage, page, rowsPerPage, count} = this.props;
  
      return <Table>
        <TableHead>
          {this.renderHeaderRows()}
        </TableHead>
        <TableBody>
          {this.renderBodyRows()}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={onChangePage}
              onChangeRowsPerPage={onChangeRowsPerPage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    }
  }

  const styles = theme => ({
    delivered: {
      color: green[500]
    }
  });
  
  export default withStyles(styles)(TransactionsTable);


// WEBPACK FOOTER //
// ./src/components/TransactionsTable.js